import { ClientState } from "../ClientState";
import { MultigameParams3 } from "../MultigameParams3";
import { Resourceful, Resourceful2 } from "../ResourceManager/Resourceful";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "../ResourceManager/ResourceManager";
import { ScreenProtocol } from "../ScreenProtocol";
import { SlotGameInitData } from "../SlotGameInitData";
import { LogGroup } from ".././MyHelpers";

export abstract class SlotGame3 implements Resourceful2
{
	public name: string = "";
	public index: number = 0;

	protected clientState: ClientState = null;

	protected features: string[] = [];

	protected initData: SlotGameInitData = null;
	protected logGroup: LogGroup = null;

	protected screenProtocol: ScreenProtocol = null;

	public constructor(initData: SlotGameInitData, multigameParams: MultigameParams3) {
		this.name = initData.Meta.GameName;
		this.index = initData.Index;
		this.initData = initData;
		this.features = initData.Feature;
		
		//this.clientState = multigameParams.clientState;

		this.screenProtocol = multigameParams.screenProtocol;
		this.logGroup = new LogGroup(["Slot3", this.name]);
	}

	public async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {
	}

	public async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
	}

	public abstract Update(): void;
	public abstract View(): HTMLElement;
	//public abstract Spin(): void;
	//public abstract OnSpinResult(spinResult: SlotSpinResult): void;

	//public abstract Bonus(): SlotBonus;

	// public abstract SelectLine(lineIndex:number): void;
	// public abstract SelectDenom(denomIndex:number): void;
	// public abstract SelectBet(betIndex: number): void;

	public abstract GameSelected(): void;
	public abstract GameExit(): void;

	public abstract Recover():void;

	// public abstract GetSelectedLineIndex(): number;
	// public abstract GetSlectedDenomIndex(): number;

	// public abstract GetPreview(): HTMLElement;

}
